import React, { Suspense } from 'react';

import { Content } from './content';
import { Title } from './empty-state.styled';
import { Wrapper } from './wrapper';

export interface Props {
	/**
	 * An image that is shown above the text. This should be used to communicate what the page is for.
	 */
	Image: React.ComponentType;
	/**
	 * A summary of why the page is shown.
	 */
	title: string | JSX.Element;
	/**
	 * Details on why the page is shown including any call to actions.
	 */
	content?: JSX.Element;
}

export const EmptyState: React.FC<Props> = ({ title, content, Image }) => (
	<Suspense fallback={null}>
		<Wrapper>
			{/* eslint-disable-next-line @atlassian/a11y/alt-text -- See https://go/a11y-alt-text for more details */}
			<Image />
			<Title>{title}</Title>
			<Content>{content}</Content>
		</Wrapper>
	</Suspense>
);
